<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <CandidateStatusListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import CandidateStatusListing from "@/views/pages/admin/candidateStatus/candidateStatusListing";

export default {
    page: {
        title: i18n.t("module.candidateStatus"),
    },
    components: { Layout, PageHeader, CandidateStatusListing },
    data() {
        return {
            title: i18n.t("module.candidateStatus"),
            items: [
                {
                    text: i18n.t("module.recruitment"),
                    href: '/recruitments',
                },
                {
                    text: i18n.t("module.candidateStatus"),
                    active: true,
                },
            ],
        };
    },
}
</script>
